import { render, staticRenderFns } from "./TemplateCardV3p2.vue?vue&type=template&id=9effc464&scoped=true&"
import script from "./TemplateCardV3p2.vue?vue&type=script&lang=js&"
export * from "./TemplateCardV3p2.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCardV3p2.vue?vue&type=style&index=0&id=9effc464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9effc464",
  null
  
)

export default component.exports